// Casca do painel: o que envolve toda tela (boundary de erro, toasts, spinner,
// stepper) e o toast global de erro do React Query. Texto de uma tela
// específica não entra aqui.
import { defineMessages } from '../core';

export const shellT = defineMessages('shell', {
  pt: {
    /// `aria-label` do spinner (leitor de tela). Sem reticências: é rótulo,
    /// não frase na tela.
    spinnerLabel: 'Carregando',
    stepperProgress: (current: number, total: number) => `Passo ${current} de ${total}`,
    /// #937 — seletor de etapa do celular (leitor de tela).
    stepperJumpAria: 'Etapa do cadastro',
    /// #937 — situação da etapa, no seletor do celular e no `title` dos círculos.
    stepStatus: { done: 'concluída', pending: 'pendente', optional: 'opcional', na: 'não se aplica' },
    toastRegion: 'Notificações',
    errorBoundary: {
      updatingTitle: 'Atualizando para a versão mais recente…',
      updatingHint: 'Uma nova versão do painel foi publicada. Recarregando para carregá-la.',
      errorTitle: 'Algo deu errado',
      errorHint: 'Tentamos exibir esta tela mas o navegador travou. O erro foi reportado automaticamente.',
      technicalDetails: 'Detalhes técnicos',
      reloadPage: 'Recarregar página',
    },
    /// Título do toast global de erro (`lib/queryClient.ts`). O corpo cru que
    /// o servidor manda continua como vem (tradução de erro do backend é a
    /// #523).
    apiError: {
      status: (status: number) => `Erro ${status}`,
      statusWithText: (status: number, statusText: string) => `Erro ${status} ${statusText}`,
      network: 'Falha de comunicação',
      unexpected: 'Erro inesperado',
    },
  },
  en: {
    spinnerLabel: 'Loading',
    stepperProgress: (current, total) => `Step ${current} of ${total}`,
    stepperJumpAria: 'Setup step',
    stepStatus: { done: 'done', pending: 'pending', optional: 'optional', na: 'not applicable' },
    toastRegion: 'Notifications',
    errorBoundary: {
      updatingTitle: 'Updating to the latest version…',
      updatingHint: 'A new version of the dashboard was published. Reloading to load it.',
      errorTitle: 'Something went wrong',
      errorHint: 'We tried to show this screen but the browser got stuck. The error was reported automatically.',
      technicalDetails: 'Technical details',
      reloadPage: 'Reload page',
    },
    apiError: {
      status: (status) => `Error ${status}`,
      statusWithText: (status, statusText) => `Error ${status} ${statusText}`,
      network: 'Connection error',
      unexpected: 'Unexpected error',
    },
  },
  es: {
    spinnerLabel: 'Cargando',
    stepperProgress: (current, total) => `Paso ${current} de ${total}`,
    stepperJumpAria: 'Paso del registro',
    stepStatus: { done: 'completado', pending: 'pendiente', optional: 'opcional', na: 'no aplica' },
    toastRegion: 'Notificaciones',
    errorBoundary: {
      updatingTitle: 'Actualizando a la versión más reciente…',
      updatingHint: 'Se publicó una nueva versión del panel. Recargando para cargarla.',
      errorTitle: 'Algo salió mal',
      errorHint: 'Intentamos mostrar esta pantalla, pero el navegador se trabó. El error se reportó automáticamente.',
      technicalDetails: 'Detalles técnicos',
      reloadPage: 'Recargar página',
    },
    apiError: {
      status: (status) => `Error ${status}`,
      statusWithText: (status, statusText) => `Error ${status} ${statusText}`,
      network: 'Error de comunicación',
      unexpected: 'Error inesperado',
    },
  },
});
